export default __webpack_public_path__ + "static/studentMobile25-7869cd82bef4edb1d3294e7692a2d79f.mp4";